import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
    public transform(items: any[], condition: any[]): any {
        return items.filter((item) => !!item[condition[0]] === condition[1]);
    }
}
